import { Image, Stack, Text } from "@bookingcom/bui-react";
import { t, useI18n } from "@bookingcom/lingojs-react";
import { CHART_HEIGHT } from "../ChartConstants";
import { ChartHeader } from "../ChartHeader";

type ChartErrorBoundaryProps = { titleText: string };

export const ChartErrorBoundary = ({ titleText }: ChartErrorBoundaryProps) => {
  const i18n = useI18n();

  return (
    <>
      <ChartHeader titleText={titleText} />
      <Stack alignItems="center" justifyContent="center" mixin={{ height: `${CHART_HEIGHT}px` }}>
        <Stack direction="row" alignItems="center" wrap="nowrap">
          <Image
            asset={{
              setName: "illustrations-partner-thumbnails",
              assetName: "RegistrationReviewRejected",
            }}
            width={30}
          />
          <Stack.Item shrink={true} mixin={{ maxWidth: "375px" }}>
            <Stack direction="column" justifyContent="center" gap={1}>
              <Text variant="strong_1">
                {i18n.trans(t("flights_airline_portal_airline_view_realtime_error_api_all_header"))}
              </Text>
              <Text variant="body_2">
                {i18n.trans(t("flights_airline_portal_airline_view_realtime_error_api_all_body"))}
              </Text>
            </Stack>
          </Stack.Item>
        </Stack>
      </Stack>
    </>
  );
};
